"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _LoadingSpinner = _interopRequireDefault(require("../loadingspinner/LoadingSpinner"));

require("./Button.css");

function Button(props) {
  var block = props.block,
      children = props.children,
      className = props.className,
      disabled = props.disabled,
      href = props.href,
      loading = props.loading,
      ariaLabel = props['aria-label'],
      primary = props.primary,
      secondary = props.secondary,
      size = props.size,
      target = props.target,
      title = props.title,
      type = props.type,
      otherProps = (0, _objectWithoutProperties2["default"])(props, ["block", "children", "className", "disabled", "href", "loading", "aria-label", "primary", "secondary", "size", "target", "title", "type"]);
  var classNames = (0, _classnames["default"])(['stx-button', {
    'stx-button--primary': primary
  }, {
    'stx-button--secondary': secondary && !primary
  }, {
    'stx-button--block': block
  }, {
    'stx-button--small': size === 'small'
  }, {
    'stx-button--large': size === 'large'
  }, {
    'stx-button--is-disabled': disabled
  }, {
    'stx-button--is-loading': loading
  }, className]);
  var ButtonTag = href && !disabled ? 'a' : 'button';
  var buttonType = ButtonTag === 'button' && type ? {
    type: type
  } : {};
  return /*#__PURE__*/_react["default"].createElement(ButtonTag, (0, _extends2["default"])({
    title: title,
    className: classNames,
    href: href,
    target: target,
    disabled: disabled,
    "aria-disabled": disabled,
    "aria-label": ariaLabel,
    "aria-busy": loading
  }, buttonType, otherProps), /*#__PURE__*/_react["default"].createElement("span", {
    className: "stx-button__text"
  }, children), /*#__PURE__*/_react["default"].createElement(_LoadingSpinner["default"], {
    className: "stx-button__spinner"
  }));
}

Button.defaultProps = {
  title: null,
  className: '',
  href: null,
  target: null,
  size: null,
  type: null,
  'aria-label': null,
  primary: false,
  disabled: false,
  loading: false,
  block: false
};
Button.propTypes = {
  /** Value given to the title attribute */
  title: _propTypes["default"].string,

  /** Value appended to the class attribute */
  className: _propTypes["default"].string,

  /**
   * Value given to the href attribute
   * Note: The Button will render as an <a> tag if this is provided
   */
  href: _propTypes["default"].string,

  /** Value given to the target attribute */
  target: _propTypes["default"].string,

  /** Sets the size of the generated button */
  size: _propTypes["default"].oneOf(['', 'small', 'large']),

  /** Sets the type of the generated button */
  type: _propTypes["default"].oneOf(['submit', 'reset', 'button']),

  /** String indicating the aria label */
  'aria-label': _propTypes["default"].string,

  /** Boolean indicating whether the button should render as primary */
  primary: _propTypes["default"].bool,

  /** Boolean indicating whether the button should render as secondary */
  secondary: _propTypes["default"].bool,

  /** Boolean indicating whether the button should render as disabled */
  disabled: _propTypes["default"].bool,

  /** Boolean indicating whether the button should render a loading spinner */
  loading: _propTypes["default"].bool,

  /** Boolean indicating whether the button should render a block button */
  block: _propTypes["default"].bool,

  /** Child elements */
  children: _propTypes["default"].node
};
var _default = Button;
exports["default"] = _default;